<template>
  <div class='design-reward'>
    <div>
      <div class='block1'></div>
      <div class='design-wrap'>
        <div class='notice'>
          <img src="../assets/img/reward/序言.png" alt="">
        </div>
        <prize-content></prize-content>
      </div>
      
    </div>
    <other-reward></other-reward>
    <div class='footer-box'>
      <div class="orgLink">
        <div
          class="link-item"
          v-for="(item, index) in logoList.list"
          :key="index"
        >
          <div class="link-item-name">{{ item.title }}</div>
          <div class="link">
            <a
              v-for="(item1, index) in item.data"
              :key="index"
              @click.stop="goLink(item1)"
            >
              <img
                :src="item1.logoSrc"
                alt=""
                :style="{ height: item1.height }"
              />
            </a>
          </div>
        </div>
      </div>
    <beian />
    </div>
  </div>
</template>

<script>
import Beian from '../components/beian.vue'
import OtherReward from '../components/designReward/otherReward.vue'
import PrizeContent from '../components/designReward/PrizeContent.vue'
import { brandHit } from "../utils/apis/brandApi";

import { reactive } from "vue";
export default {
  components: {  PrizeContent, Beian, OtherReward },
  name: 'designReward',
  setup() {
    const logoList = reactive({
      list: [
        {
          title: "主 办 方",
          data: [
            {
              name: "明基",
              logoSrc: require("../assets/img/infoPic/BenQ.png"),
              href: "https://s.tb.cn/c.0uNQBj",
              height: "23px",
            },
          ],
        },
        {
          title: "协 办 方",
          data: [
            {
              name: "CG模型网",
              logoSrc: require("../assets/img/infoPic/moxing.png"),
              href: "https://www.cgmodel.com/",
              height: "26px",
            },
            {
              name: "蓝铅笔",
              logoSrc: require("../assets/img/infoPic/lanqianbi.png"),
              href: "https://www.lanqb.com/",
              height: "27px",
            },
            {
              name: "Wuhu",
              logoSrc: require("../assets/img/infoPic/Wuhu.png"),
              href: "https://weibo.com/u/5836279440",
              height: "45px",
            },
            {
              name: "GGAC",
              logoSrc: require("../assets/img/infoPic/GGAC.png"),
              href: "https://www.ggac.com/v2/home",
              height: "33px",
            },
          ],
        },
        {
          title: "联合品牌",
          data: [
            {
              name: "Pantone",
              logoSrc: require("../assets/img/infoPic/pantone.png"),
              href: "https://pantonecn.com",
              height: "44px",
            },
            {
              name: "CBS",
              logoSrc: require("../assets/img/infoPic/colebrook.png"),
              href: "https://mall.jd.com/view_page-257315110.html",
              height: "34px",
            },
            {
              name: "赫曼米勒",
              logoSrc: require("../assets/img/infoPic/herman.png"),
              href: "https://hermanmiller.tmall.com/",
              height: "27px",
            },
            {
              name: "绘王",
              logoSrc: require("../assets/img/infoPic/huion.png"),
              href: "https://store.huion.cn/",
              height: "24px",
            },
            {
              name: "ikbc",
              logoSrc: require("../assets/img/infoPic/ikbc.png"),
              href: "http://www.ikbc.com.cn",
              height: "28px",
            },
            {
              name: "金士顿",
              logoSrc: require("../assets/img/infoPic/kingstone.png"),
              href: "https://www.kingston.com/cn",
              height: "23px",
            },
          ],
        },
        {
          title: "支持单位",
          data: [
            {
              name: "ill",
              logoSrc: require("../assets/img/infoPic/ihdt.png"),
              href: "http://c4datc.com",
              height: "40px",
            },
            {
              name: "AD518",
              logoSrc: require("../assets/img/infoPic/ad518.png"),
              href: "http://www.ad518.com",
              height: "20px",
            },
            {
              name: "CDBC",
              logoSrc: require("../assets/img/infoPic/cdbc.png"),
              href: "https://weibo.com/207979150/",
              height: "35px",
            },
            {
              name: "涂鸦王国",
              logoSrc: require("../assets/img/infoPic/tuya.png"),
              href: "https://www.gracg.com/",
              height: "25px",
            },
          ],
        },
        {
          title: "字体支持",
          data: [
            {
              name: "造字工房",
              logoSrc: require("../assets/img/infoPic/zaozi.png"),
              href: "http://makefont.com",
              height: "40px",
            },
          ],
        },
      ],
    });
    function goLink(item) {
      console.log(item);
      brandHit({ brand: item.name }).then((res) => {
        if (res.data.code === 200) {
          window.location.href = item.href;
        }
      });
    }
    return {
      logoList,
      goLink
    };
  },
}
</script>

<style lang='less' scoped>
@font-face {
  font-family: "SS";
  src: url("../assets/fonts/SWEISPRINGCJKSC-BLACK.TTF") format("truetype");
}
@font-face {
  font-family: "SSB";
  src: url("../assets/fonts/SWEISPRINGCJKSC-BOLD.TTF") format("truetype");
}
@font-face {
  font-family: "SSP";
  src: url("../assets/fonts/SWEISPRINGSUGARCJKSC-BLACK.TTF") format("truetype");
}
@font-face {
  font-family: "SSPB";
  src: url("../assets/fonts/SWEISPRINGSUGARCJKSC-BOLD.TTF") format("truetype");
}
@font-face {
  font-family: "TCH";
  src: url("../assets/fonts/FZLTCHJW.TTF") format("truetype");
}
@font-face {
  font-family: "TH";
  src: url("../assets/fonts/FZLTHJW.TTF") format("truetype");
}
@font-face {
  font-family: "XH";
  src: url("../assets/fonts/FZLTXHJW.TTF") format("truetype");
}
.design-reward {
  .design-wrap {
    width: 888px;
    margin: 0 auto;
    .notice {
      width: 771px;
      height: 500px;
      margin: 0 auto;
    }
  }
    background-image: url("../assets/img/detailPic/bg.png") !important;
    background-size: cover;
    background-position: center;
  .block1 {
    height: 186px;
    
  }
  
  .footer-box {
    // height: 330px;
    box-sizing: border-box;
    .orgLink {
      background-color: #272727;
      height: 378px;
      padding-top: 72px;
      padding-bottom: 72px;
      :nth-child(5) {
        .link-item-name {
          transform: translateY(6px);
        }
      }
      .link-item {
        overflow: hidden;
        width: 761px;
        margin: 0 auto;
        margin-bottom: 25px;
        .link-item-name {
          float: left;
          line-height: 45px;
          width: 85px;
          font-family: "FZLTHJW";
          font-size: 20px;
          color: #fff;
          text-align-last: justify;
          text-align: justify;
        }
        .link {
          margin-left: 132px;
          line-height: 45px;
          font-size: 0px;

          a {
            display: inline-block;
            line-height: 45px;
            margin-right: 27px;
            cursor: pointer;
            img {
              vertical-align: middle;
            }
          }
        }
      }
    }
    .beian {
      // height: 174px;
      // line-height: 174px;
      text-align: center;
      color: #7e3e34;
      padding-top: 20px;
      .beian-box {
        padding: 12px 0 13px;
        text-align: center;
        div {
          display: inline-block;
          font-size: 12px;
          color: rgb(152, 152, 152);
          a {
            text-decoration: none;
            color: rgb(152, 152, 152);
          }
          img {
            height: 12px;
            width: 12px;
            vertical-align: middle;
            // margin-top: 3px;
            margin-right: 6px;
          }
        }
        .line {
          vertical-align: middle;
          background: rgb(152, 152, 152);
          height: 12px;
          font-size: 12px;
          margin: 0 10px;
          width: 1px;
        }
      }
    }
  }
}
</style>